<template>
  <v-app-bar app flat class="custom-app-bar">
    <v-container>
      <div class="navbar-content">
        <!-- Left: Brand Logo -->
        <div class="brand" @click="$router.push('/')">
          <img
            src="@/assets/HECS-logo-extended-long2.png"
            alt="Health Espresso Logo"
            class="logo-img"
          />
        </div>

        <!-- Right: Logout Button -->
        <div class="nav-links">
          <v-btn class="logout-btn" @click="logout" elevation="0" color="#e74c3c" dark>
  <v-icon left>mdi-logout</v-icon>
  Logout
</v-btn>

        </div>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import axios from "axios";

export default {
  name: "AppNavbar",
  methods: {
    async logout() {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/logout`, {}, {
          withCredentials: true
        });
      } catch (error) {
        console.log("Logout error:", error);
      }
      localStorage.removeItem("token");
      window.location.href = "/#";
    }
  }
};
</script>

<style scoped>
.custom-app-bar {
  background: linear-gradient(to right, #ffffff, #f8f9fa);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 0;
  z-index: 1000;
}

/* Layout */
.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

/* Logo */
.brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.logo-img {
  height: 48px;
  width: auto;
  object-fit: contain;
}

/* Logout button */
.nav-links {
  display: flex;
  align-items: center;
}

.logout-btn {
  background-color: #e74c3c !important;
  color: white !important;
  border-radius: 6px;
  font-weight: 500;
  text-transform: none;
}

.logout-btn:hover {
  background-color: #c0392b !important;
  color: white !important;
}

:deep(.logout-btn .v-btn__overlay),
:deep(.logout-btn:hover .v-btn__overlay) {
  background-color: transparent !important;
}



/* Responsive */
@media (max-width: 768px) {
  .logo-img {
    height: 34px;
  }

  .logout-btn {
    font-size: 0.875rem;
    padding: 6px 12px;
  }
}
</style>
